import React, { useState, useEffect } from "react";
import { FaTable } from "react-icons/fa";
import { tableConstants } from "./TimeTableConstant";
import Table from "../../../components/Table/Table";
import Loader from "../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import CardHeader from "../../../components/Card/CardHeader";
import Pagination from "../../../components/Pagination/Pagination";
import { enqueueSnackbar } from "notistack";
import { deleteTimeTable, getTimeTables } from "../../../services/AppManagement/TimeTableService";

const TimeTableList = () => {
  const [data, setData] = useState([]);
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const [isLoader, setIsLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(1);

  async function fetchTimeTable({ selected = 0 }) {
    setCurrentPage(selected);
    const page = selected + 1;
    const session_id = localStorage.getItem('session_id');
    try {
      setIsLoader(true);
      const response = await getTimeTables(session_id, page);
      if (response.status === 200) {
        setData(response.data.data);
        setLastPage(response.data.last_page);
      }
    }
    catch (error) {
      console.error("API Error:", error.response);
    }
    finally {
      setIsLoader(false);
    }
  }

  useEffect(() => {
    fetchTimeTable({ selected: 0 });
  }, []);

  const timeTableDelete = async (id) => {
    try {
      const response = await deleteTimeTable(id);
      if (response.status === 200) {
        enqueueSnackbar("TimeTable Deleted Successfully", { variant: "success" });
        fetchTimeTable({ selected: 0 });
      }
    }
    catch (error) {
      console.error("API Error:", error.response);
    }
  }

  return (
    <div className="card">
      <CardHeader
        title="TimeTable List"
        icon={<FaTable />}
        button={permissions.includes('time_table.create') &&
          <div>
            <Link to="/upload/timetable/list"
              className="btn btn-primary mx-2">Upload TimeTable</Link>
            <Link to="/timetable/create"
              className="btn btn-primary">Add TimeTable</Link>
          </div>}
      />
      <div className="card-body">
        {isLoader ? <Loader /> :
          <div className="row mt-3">
            {data && (
              <React.Fragment>
                <Table
                  cols={tableConstants(permissions, timeTableDelete)}
                  data={data}
                  hover={true}
                />
                <Pagination
                  totalPage={lastPage}
                  currentPage={currentPage}
                  handlePageChange={(i) => fetchTimeTable(i)}
                ></Pagination>
              </React.Fragment>
            )}
          </div>}
      </div>
    </div>
  )
};
export default TimeTableList;
